<section class="rs-content-wrapper rs-header-has-level2">
  <main id="maincontent" role="main">
    <div class="rs-fe3"></div>
    <div class="row">
      <div class="columns small-12">
        <a href="javascript:void(0)" class="rs-btn rs-btn-third rs-btn-third-icon-left"
          ><i class="rs-icon-btn-third rs-margin-right1" aria-hidden="true"></i>Back</a
        >
        <div class="rs-me"></div>
        <h1 class="rs-tit4">{{ 'flexEmergency.manage.title' | translate }}</h1>
        <ng-container>
          <p class="rs-txt-s5">{{ 'flexEmergency.manage.selectMobile' | translate }}</p>
        </ng-container>
        <div class="rs-flex-row">
          <div class="rs-flex-columns small-12 medium-6">
            <div class="rs-panel-flex">
              <div class="rs-panel-flex-cell rs-bg-grey2 clearfix">
                <div class="rs-flex-row rs-flex-middle-small-only">
                  <div
                    class="panel rs-inline-block rs-wd-s14 rs-h-s2 rs-no-padding rs-margin-bottom1 rs-bg-skeleton rs-anim-loading"
                  ></div>
                </div>
                <div class="rs-flex-row rs-flex-middle-small-only">
                  <div
                    class="panel rs-maxw rs-h-s4 rs-h-m5 rs-no-padding rs-margin-bottom2 rs-bg-skeleton rs-anim-loading"
                  ></div>
                </div>
              </div>
            </div>
          </div>
          <div class="rs-flex-columns small-12 medium-6">
            <div class="rs-panel-flex">
              <div class="rs-panel-flex-cell rs-bg-grey2 clearfix">
                <div class="rs-flex-row rs-flex-middle-small-only">
                  <div
                    class="panel rs-inline-block rs-wd-s14 rs-h-s2 rs-no-padding rs-margin-bottom1 rs-bg-skeleton rs-anim-loading"
                  ></div>
                </div>
                <div class="rs-flex-row rs-flex-middle-small-only">
                  <div
                    class="panel rs-maxw rs-h-s4 rs-h-m5 rs-no-padding rs-margin-bottom2 rs-bg-skeleton rs-anim-loading"
                  ></div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="rs-me"></div>
        <h2 class="rs-tit5">F.A.Q.</h2>
        <p [innerHTML]="'flexEmergency.manage.faqContent' | translate: true"></p>
      </div>
    </div>
    <div class="rs-le2"></div>
  </main>
</section>
